




























import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch, Prop, Emit, Ref, PropSync, Model } from 'vue-property-decorator'
import RelationApi from '../../services/RelationApi'
import RelationContactApi from '@/services/RelationContactApi'

@Component
export default class RelationSelector extends Vue {
  @Ref() readonly boom!: any
  @PropSync('relationId', { type: String }) relationIdSynced!: string
  @PropSync('loading', { type: Boolean }) loadingSynced!: boolean
  @Prop(Boolean) readonly isReset: any
  @PropSync('form', { type: Object }) formSynced!: any

  items: Array<any> = []

  loadingDetails = false
  steps: Array<any> = []
  open: Array<any> = []
  active: Array<any> = []
  selected: any = null
  selectedType = ''
  newParent: any = null

  mounted () {
    this.getTree()
  }

  formatTree (object: any, isRoot = false) {
    if (isRoot) {
      const obj = object.parent
      if (obj.children) {
        delete object.parent
        obj.children = []
        const keys = Object.keys(object)
        for (let i = 0; i < keys.length; i++) {
          obj.children = obj.children.concat(object[keys[i]])
        }
      }
      return obj
    } else {
      let array: Array<any> = []
      delete object.parent
      const keys = Object.keys(object)
      for (let i = 0; i < keys.length; i++) {
        array = array.concat(object[keys[i]])
      }
      return array
    }
  }

  async loadChildren (val: any) {
    // console.log(val)
    this.loadingSynced = true
    const dt = await new RelationApi(0).relationTree({ parentId: val.id }) as any
    this.loadingSynced = false
    val.children = this.formatTree(dt.data)
  }

  async getTree () {
    this.loadingSynced = true
    const dt = await new RelationApi(0).relationTree() as any
    this.loadingSynced = false
    const parent = dt.data.parent
    this.items = [this.formatTree(dt.data, true)]
    this.$nextTick(() => {
      if (this.boom) {
        this.boom.updateAll(true)
        this.active = [parent]
        this.clicked(parent)
      }
    })
  }

  async clicked (val: any) {
    // console.log('triggerd!')
    this.loadingDetails = true
    this.loadingSynced = true
    this.relationIdSynced = val.id
    // console.log(val)
    if (val.type === 'Relation') {
      const dt = await new RelationApi(0).getRelationById(val.id) as any
      this.selectedType = 'Relation'
      this.selected = dt.data
      // console.log('SELECTED')
      // console.log(this.formSynced)
    } else if (val.type === 'RelationContact') {
      const dt = await new RelationContactApi(0).findContactsByRelationContactId(val.id) as any
      this.selectedType = 'RelationContact'
      this.selected = dt.data
    }
    this.loadingDetails = false
    this.loadingSynced = false
  }

  @Watch('active', { deep: true })
  activeOnChanged (val: any, oldVal: any) {
    if (val.length > 0) {
      this.$emit('update:value', val[0].id)
      this.$emit('input', val[0].id)
    }
  }

  @Watch('relationIdSynced')
  relationIdOnChanged (val: any, oldVal: any) {
    this.$emit('update:value', val)
    this.$emit('input', val)
  }

  @Watch('isReset')
  selectedOnChanged (val: any, oldVal: any) {
    if (val) {
      this.getTree()
    }
  }
}
